
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Kunde from './Kunde';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import Fab from '@material-ui/core/Fab';
import SwipeableViews from 'react-swipeable-views';
import Slide from '@material-ui/core/Slide';
import Zoom from '@material-ui/core/Zoom';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';
import {
  DoneIcon,
  MoreVert,
  EditIcon,
  PersonAddIcon,
  DirectionsIcon,
  CameraIcon,
  ArrowForwardIcon,
} from "../bundles/IconsBundle";
// import Loader from '../extensions/Loader';
import { connect } from 'react-redux';
import { setTitle } from '../actions/AppActions';
import {
  SelectedAppSelector,
  SelectedAppPositionsSelector,
  SelectedAppMonteureSelector,
  SelectedAppAttachmentsSelector,
  SelectedAppPhotosSelector
} from '../selectors/SelectedAppointmentSelector';
//import { SelectAppointmentByID } from '../actions/TaskActions';
import {
  SelectAppointmentByID,
  SetPropertyValue,
  SavePropertyValue,
  SaveData,
  FotoAdd,
  FotoRemove,
  CurrentCompanyID
} from "../actions/TaskActions";
import moment from 'moment';
import TakePhoto from './extensions/TakePhoto';
import ConfirmAuftragDialog from './dialogs/ConfirmAuftragDialog';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';
// import GridList from '@material-ui/core/GridList';
// import GridListTile from '@material-ui/core/GridListTile';
// import GridListTileBar from '@material-ui/core/GridListTileBar';
// import { DeleteIcon } from '../bundles/IconsBundle';
// import Button from '@material-ui/core/Button';
import MessageBox from './dialogs/MessageBox';
import { Text } from '../extensions/LangaugeContainer';
// import { setTimeout } from 'timers';
// import { SHOWN_TYPE_ERLEDIGTE } from "../helpers/constants";


function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3, height: "calc(100vh - 105px)" }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = {
  root: {
    flexGrow: 1,
    width: '100%',
  },
  fabfirst: {
    position: 'fixed',
    right: "20px",
    bottom: "80px",
    zIndex: 998,
    boxShadow: "1px 1px 1px 1px #AAA",
    backgroundColor: "#03A9F4",
    color: "white"
  },
  fabsecond: {
    position: 'fixed',
    right: "20px",
    bottom: "20px",
    zIndex: 999,
    boxShadow: "1px 1px 1px 1px #AAA",
    backgroundColor: "#03A9F4",
    color: "white"
  },
  direction: {
    rtl: 'ltr'
  },
  slideMenu: {
    position: "fixed",
    right: "0px",
    bottom: "80px",
    width: "80px",
    height: "300px",
    background: "#ffffff",
    zIndex: 999,
    boxShadow: "1px 1px 1px 1px #AAA",
  },
  // qrIcon: {
  //   path: '<path fill="#000000" d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z" />'
  // },
  tabsRoot: {
    borderBottom: '1px solid #cecece',
  },
};

class TaskView extends React.Component {

  state = {
    value: 0,
    slideMenu: false,
    TakePhotoOpen: false,
    confirmAuftragDialogOpen: false,
    //dialogApp: {},
    _deleteImageMessageOpen: false,
    type: 0,
    swipeDisabled: false
  };

  file_input = [];

  componentDidMount() {
   // moment.locale("de");
    this.props.SelectAppointmentByID(this.props.match.params.id);    
  }

  handleChange = (event, value) => {
    this.setState({ ...this.state, value });
  };

  handleSlideMenuChange = (event) => {
    this.setState({ ...this.state, slideMenu: !this.state.slideMenu });
  }

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  AddPerson = () => {
    this.props.history.push(
      "/addperson/" + this.props.match.params.id + "/" + -1
    );
  }

  EditCode = () => {
    this.props.history.push(
      "/manualcode/" + this.props.match.params.id
    );
  }

  ScanCode = () => {
    this.props.history.push(
      "/scancode/" + this.props.match.params.id
    );
  }
  SignAuftrag = () => {
    if (typeof (this.props.files[0]) === "object") {
      if (this.props.files[0].Attachment != null) {
        this.props.history.push(
          "/signauftrag/" + this.props.match.params.id
        );
      } else {
        alert("Dokument nicht existiert!");
      }
    } else {
      alert("Dokument nicht existiert!");
    }

  }

  SignAuftragMultiple = () => {
    this.props.CurrentCompanyID(this.props.app.IdFirma);
    this.props.history.push(
      "/signauftragmultiple/" + this.props.match.params.id
    );
    // if (typeof (this.props.files[0]) === "object") {
    //   if (this.props.files[0].Attachment != null) {
    //     this.props.history.push(
    //       "/signauftragmultiple/" + this.props.match.params.id
    //     );
    //   } else {
    //     alert("Dokument nicht existiert!");
    //   }
    // } else {
    //   alert("Dokument nicht existiert!");
    // }

  }

  fotoMachen = () => {
    this.setState({ ...this.state, TakePhotoOpen: true }); // images: this.state.images
  };

  closeTakePhoto = () => {
    this.setState({ ...this.state, TakePhotoOpen: false });
  };

  selectFile = event => {
    event.preventDefault();
    console.log("FI", this.file_input);
    this.file_input = document.createElement("input");
    this.file_input.addEventListener(
      "change",
      this.uploadFile.bind(this),
      false
    );
    this.file_input.type = "file";
    this.file_input.click();
  };

  uploadFile = () => {
    this.getBase64(this.file_input.files[0]).then(src =>
      this.props.FotoAdd(this.props.app, src)
    );
  };

  onRemoveImage = () => {
    var st = this.state;
    //st.images = this.state.images.filter((item,index) => index !== this.state._deleteImageId)
    this.props.FotoRemove(st._deleteImageId);
    st._deleteImageId = -1;
    st._deleteImageMessageOpen = false;
    this.setState(st);
};

  removeImage = (idToRemove) => {
    var st = this.state;
    st._deleteImageId = idToRemove;
    st._deleteImageMessageOpen = true;
    this.setState(st);
  }

  handleCloseMessage = () => {
    var st = this.state;
    st._deleteImageMessageOpen = false;
    this.setState(st);
  };

  getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
    //reader.onload = () => resolve(reader.result);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
                var newDataUri = this.imageToDataUri(img, img.width, img.height);
                resolve(newDataUri);
            };

      reader.onerror = error => reject(error);
    };
  });
}

imageToDataUri = (img, width, height) => {

  // create an off-screen canvas
  var canvas = document.createElement('canvas'),
      ctx = canvas.getContext('2d');

  // set its dimension to target size
  canvas.width = width;
  canvas.height = height;

  // draw source image into the off-screen canvas:
  ctx.drawImage(img, 0, 0, width, height);

  // encode image to data-uri with base64 version of compressed image
  return canvas.toDataURL('image/jpeg', 0.1);
}

  finishAuftrag = async () => {
    await this.props.SaveData(this.props.app, { Geliefert: 1 })
   //console.log("Saved to database");
    this.setState({
      ...this.state,
      type: 0,
      confirmAuftragDialogOpen: false,
    })
    // after the auftag is finished , it's closed and redirected to view erledigte
    //this.props.ChangeFilter(SHOWN_TYPE_ERLEDIGTE);
    this.props.history.push(
      "/"
    );
  }

  checkAuftragStatus = (geliefert) => {
    // if (geliefert === 0) {
    //   alert('Sie müssen einen auftrag status auswählen')
    // } else {
      if (geliefert === 4 && (this.props.app.GeliefertDescription === "" || this.props.app.GeliefertDescription === null)) {
        alert('Sie müssen ein kommentar eintragen')
      } else {
        if (geliefert === 4 && this.positionCheck()) {
          this.setState({ ...this.state, type: 0, confirmAuftragDialogOpen: true })
          //confirm("Alle positionen sind abgehakt aber der auftrag status is 'Teilweise',Sind Sie sicher dass Sie fortfahren wollen?");
        } else if (geliefert === 3 && !this.positionCheck()) {
          this.setState({ ...this.state, type: 1, confirmAuftragDialogOpen: true })
          //confirm("Nicht alle positionen sind abgehakt aber der auftrag status is 'Fertig',Sind Sie sicher dass Sie fortfahren wollen?");
        } else {
          this.setState({ ...this.state, type: 2, confirmAuftragDialogOpen: true })
        }
      }
    // }
  }

  positionCheck = () => {
    // return this.props.position.map(val => {
    //   return val.Selected === 0
    // }).length === 0
    return this.props.position.filter(e => e.Selected === 0).length === 0 ? true : false
  }

  handleCloseDialogs = () => {
    this.setState({
      ...this.state,
      confirmAuftragDialogOpen: false,
    });
  };

  startMapSwipe = () => {
    this.setState({
      ...this.state,
      swipeDisabled: true,
    });
  }

  endMapSwipe = () => {
    this.setState({
      ...this.state,
      swipeDisabled: false,
    });
  }

  render() {
   // console.log("TaskView props: ", this.props);
    const { value } = this.state;
    const readOnly = this.props.settings.PrivilegedUser;
   // const fotos = this.props.fotos || [];
    // console.log("Props TaskView position:", this.props.position);
    // console.log("Props TaskView monteure:", this.props.persons);
    //console.log ("props app", this.props.app);
    return (
      <div>
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            scrollButtons="auto"
            style={styles.tabsRoot}
          >
            <Tab label={<Text tid="customer"/>} />
            <Tab label={<Text tid="positions"/>} />
            <Tab label={<Text tid="orderFinish"/>} />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={styles.direction.rtl === 'rtl' ? 'x-reverse' : 'x'}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
          enableMouseEvents={true}
          //hysteresis={0.75} //trenutno disablovano skrolovanje na tabu kunde zbog karte
          //threshold={7}
          disabled={this.state.swipeDisabled}
        >
          <TabContainer dir={styles.direction.rtl}><Kunde app={this.props.app} fotos={this.props.fotos} monteure={this.props.persons} SetPropertyValue={this.props.SetPropertyValue} SaveData={this.props.SaveData} style={{ overflow: 'hidden' }} startMapSwipe={this.startMapSwipe} endMapSwipe={this.endMapSwipe}/></TabContainer>
          <TabContainer dir={styles.direction.rtl}><StepThree disabled={readOnly} position={this.props.position} SaveData={this.props.SaveData} SetPropertyValue={this.props.SetPropertyValue} enteredData={this.props.enteredData} app={this.props.app} style={{ overflow: 'hidden' }} /></TabContainer>
          <TabContainer dir={styles.direction.rtl}><StepTwo disabled={readOnly} app={this.props.app} SetPropertyValue={this.props.SetPropertyValue} SaveData={this.props.SaveData} SignAuftrag={this.SignAuftrag} SignAuftragMultiple={this.SignAuftragMultiple} style={{ overflow: 'hidden' }} /></TabContainer>
        </SwipeableViews>
        {/* {value === 0 && <TabContainer dir={styles.direction.rtl}><Kunde app={this.props.app} fotos={this.props.fotos} monteure={this.props.persons} SetPropertyValue={this.props.SetPropertyValue} SaveData={this.props.SaveData} style={{ overflow: 'hidden' }} /></TabContainer>}
        {value === 1 && <TabContainer dir={styles.direction.rtl}><StepThree position={this.props.position} SaveData={this.props.SaveData} SetPropertyValue={this.props.SetPropertyValue} enteredData={this.props.enteredData} app={this.props.app} style={{ overflow: 'hidden' }} /></TabContainer>}
        {value === 2 && <TabContainer dir={styles.direction.rtl}><StepTwo app={this.props.app} SetPropertyValue={this.props.SetPropertyValue} SaveData={this.props.SaveData} SignAuftrag={this.SignAuftrag} style={{ overflow: 'hidden' }} /></TabContainer>} */}

        <Zoom in={!this.state.slideMenu}>
          <Fab size='medium'
            style={styles.fabfirst}
            aria-label="Options"
            onClick={() => { this.handleSlideMenuChange() }}
            disabled={readOnly}
          >
            <MoreVert />
          </Fab>
        </Zoom>
        <Fab size='medium'
          style={styles.fabsecond}
          aria-label="Done"
          onClick={() => this.checkAuftragStatus(this.props.app.Geliefert)}
          disabled={(this.props.app.Geliefert === 1) || readOnly}
        >
          <DoneIcon />
        </Fab>
        <Slide in={this.state.slideMenu} direction="left">
          <Paper display="block" style={styles.slideMenu}>
            <div style={{ marginTop: "5px" }}>
              <IconButton
                aria-label="Edit"
                onClick={this.EditCode}
              >
                <EditIcon style={{ color: "#00B0DE" }} />
              </IconButton>
            </div>
            <div>
              <IconButton
                aria-label="Add"
                onClick={this.AddPerson}
              >
                <PersonAddIcon style={{ color: "#00B0DE" }} />
              </IconButton>
            </div>
            <div>
              <IconButton
                aria-label="Barcode"
                onClick={this.ScanCode}
              >
                <SvgIcon>
                  <path fill="#00B0DE" d="M3,11H5V13H3V11M11,5H13V9H11V5M9,11H13V15H11V13H9V11M15,11H17V13H19V11H21V13H19V15H21V19H19V21H17V19H13V21H11V17H15V15H17V13H15V11M19,19V15H17V19H19M15,3H21V9H15V3M17,5V7H19V5H17M3,3H9V9H3V3M5,5V7H7V5H5M3,15H9V21H3V15M5,17V19H7V17H5Z" />
                </SvgIcon>
              </IconButton>
            </div>
            <div>
              <IconButton
                aria-label="Directions"
                href={
                 (this.props.app.Lat === null || this.props.app.Lng === null) === true ?  ("google.navigation:q=" +
                 this.props.app.EkStrasse +
                 " " +
                 this.props.app.EkPLZ +
                 " " +
                 this.props.app.EkOrt): ("google.navigation:q=" +
                 this.props.app.Lat +
                 " " +
                 this.props.app.Lng)
                }
              >
                <DirectionsIcon style={{ color: "#00B0DE" }} />
              </IconButton>
            </div>
            <div>
              <IconButton
                aria-label="Camera"
                onClick={this.selectFile}
              >
                <CameraIcon style={{ color: "#00B0DE" }} />
              </IconButton>
            </div>
            <div>
              <IconButton aria-label="Delete" onClick={() => { this.handleSlideMenuChange() }}>
                <ArrowForwardIcon style={{ color: "#00B0DE" }} />
              </IconButton>
            </div>
          </Paper>
        </Slide>

        {/* <Table>
          <TableBody>
            <TableRow >
              <TableCell style={{ border: 0 }}>
                <GridList cellHeight={160} cols={3}>
                  {fotos.map((tile, index) => (
                    <GridListTile cols={1} key={index} style={{ border: '1px solid #DDD' }}>
                      <img src={tile.data} alt="" />
                      <GridListTileBar
                        actionIcon={
                          <Button onClick={() => { this.removeImage(tile.id) }}>
                            <DeleteIcon color="secondary" />
                          </Button>
                        }
                      />
                    </GridListTile>
                  ))}
                </GridList>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table> */}
        <MessageBox
        open={this.state._deleteImageMessageOpen}
        Title={<Text tid="deletePhoto"/>}
        MessageBox={<Text tid="bockDeleteMessage"/>}
        AcceptText={<Text tid="delete"/>}
        CancelText={<Text tid="cancel"/>}
        handleClose={this.handleCloseMessage}
        handleAccept={this.onRemoveImage} />

        <TakePhoto
          open={this.state.TakePhotoOpen}
          handleClose={this.closeTakePhoto}
          handleTakeScreenshot={this.handleTakeScreenshot}
        />
        <ConfirmAuftragDialog
          open={this.state.confirmAuftragDialogOpen}
          type={this.state.type}
          handleClose={this.handleCloseDialogs}
          finishAuftrag={this.finishAuftrag} />
      </div>
    );
  }
}

TaskView.propTypes = {
  app: PropTypes.object.isRequired,
  // notes: PropTypes.array.isRequired,
  // attachments: PropTypes.array.isRequired,
  // fotos: PropTypes.array.isRequired,
  setTitle: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  app: SelectedAppSelector(state),
  position: SelectedAppPositionsSelector(state),
  persons: SelectedAppMonteureSelector(state),
  enteredData: state.tasks.enteredData,
  files: SelectedAppAttachmentsSelector(state),
  fotos: SelectedAppPhotosSelector(state),
  settings: state.settings
});

//const withLoader = Loader(TaskView);

const connected = connect(mapStateToProps, {
  setTitle,
  SelectAppointmentByID,
  SetPropertyValue,
  SavePropertyValue,
  SaveData,
  FotoAdd,
  FotoRemove,
  CurrentCompanyID
})(TaskView);

export default withRouter(connected);